import { SharedService } from './../../shared/shared.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AppConfigData } from '../config/appConfigData';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { url } from 'inspector';
import { LocalStorageService } from './localStorage.service';
import { LoaderService } from './loader.service';
import { Validations } from '../../shared/constants/validations';
import { SweetAlertIcon } from '../../shared/constants/enum';
@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  ServiceError = Validations.ServiceError;
  constructor(
    private http: HttpClient,
    private router: Router,
    private loaderService: LoaderService,
    private SharedService: SharedService,
    private localStorageService: LocalStorageService
  ) {}

  exportReports(payload: any) {
    const headers = new HttpHeaders({
      // 'No-Intercept': 'true', // Custom header to skip interceptor
    });

    // Build the URL
    let url = `${AppConfigData.exportReportsUrl}`;

    // Append ProjectIds if they exist and are not 'all'
    if (payload?.ProjectIds && payload?.ProjectIds.length) {
      url +=
        payload?.ProjectIds !== 'all'
          ? `?${payload.ProjectIds.map(
              (id: string) => `ProjectIds=${encodeURIComponent(id)}`
            ).join('&')}`
          : '';
    }

    // Append BatteryStatus if it exists
    if (payload?.BatteryStatus) {
      url += `${
        url.includes('?') ? '&' : '?'
      }BatteryStatus=${encodeURIComponent(payload.BatteryStatus)}`;
    }

    // Append Utility if it exists
    if (payload?.Utility) {
      url += `${url.includes('?') ? '&' : '?'}Utility=${encodeURIComponent(
        payload.Utility
      )}`;
    }

    // Make the HTTP GET request
    this.http
      .get(url, {
        headers,
        responseType: 'blob', // We expect a binary response (blob)
      })
      .subscribe(
        (blob) => {
          this.loaderService.setLoading(false);
          // Create a link element for the file download
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'Reports'; // Set the download filename

          // Append the link to the body, click it, then remove it
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        (error) => {
          this.SharedService.showMessageDialog(
            error.error.message,
            this.ServiceError.Error,
            SweetAlertIcon.ERROR
          );
          this.loaderService.setLoading(false);
          console.error('Error downloading the report: ', error);
        }
      );
  }

  exportReport(payload: any, reportType: string) {
    let url: string;
    let fileName: string;
    ///debugger
    //alert(reportType)
    // Determine the URL and filename based on the report type

    console.log(payload);
    console.log(reportType);

    switch (reportType) {
      case 'BatteryStatus':
        url = AppConfigData.exportReportsUrl;
        fileName = 'Battery Status Report.xlsx';
        break;
      case 'activation':
        url = AppConfigData.getActivationStatusReportUrl;
        fileName = 'Activation Status Report.xlsx';
        break;
      case 'ScheduleBilling':
        url = AppConfigData.getScheduleBillingReportUrl;
        fileName = 'Schedule Billing Report.xlsx';
        break;
      case 'consumption':
        url = AppConfigData.getPrepaidConsumptionReportUrl;
        if (payload.consumption_Range == 'Day Wise') {
          fileName = 'Consumption Report Day wise.xlsx';
        } else {
          fileName = 'Consumption Report Range wise.xlsx';
        }
        break;
      case 'postpaid':
        url = AppConfigData.getPostpaidConsumptionReportUrl;
        fileName = 'Consumption Postpaid Report.xlsx';
        break;
      /*  case 'Invoice_Consumption_Reports':
        url = AppConfigData.getPostpaidConsumptionReportUrl;
        fileName = 'Invoice Consumption Reports.xlsx';
        break; */
      case 'Statement Consumption Report':
        url = AppConfigData.getPostpaidConsumptionReportUrl;
        fileName = 'Statement Consumption Report.xlsx';
        break;
      case 'Bill_Wise_Consumption_Reports':
        url = AppConfigData.getPostpaidConsumptionReportUrl;
        fileName = 'BillWise Consumption Reports.xlsx';
        break;
      case 'DeviceCommunications':
        url = AppConfigData.getDeviceCommunicationnReportUrl;
        fileName = 'Device Communication Report.xlsx';
        break;
      case 'MeterReadings':
        url = AppConfigData.getMeterReadingReportUrl;
        fileName = 'Meter Readings Report.xlsx';
        break;
      case 'BillGeneration':
        url = AppConfigData.getBillGenerationReportUrl;
        fileName = 'Billing And Collection Report.xlsx';
        break;
      case 'WalletBalance':
        url = AppConfigData.getWalletBlanceGenerationReportUrl;
        //fileName = 'Wallet_Balance_Report.xlsx';
        fileName = 'Consumer Wallet Report.xlsx';

        break;
      case 'WalletHistory':
        url = AppConfigData.getWalletHistoryReportUrl;
        fileName = 'Wallet History Report.xlsx';
        break;
      case 'Settlment':
        url = AppConfigData.getsettlementReportUrl;
        fileName = 'Settlments.xlsx';
        break;
      case 'Payments':
        url = AppConfigData.getsettlementReportUrl;
        fileName = 'Payments.xlsx';
        break;
      case 'monthwiseBalance':
        url = AppConfigData.getMonthlyBalanceReport;
        fileName = 'Monthwise Balance.xlsx';
        break;
      case 'daily Consumption':
        url = AppConfigData.getgetdailyconsumptionReport;
        fileName = 'Daily Consumption.xlsx';
        break;
      case 'HighConsumption':
        url = AppConfigData.getHighConsumptionReportUrl;
        fileName = 'High Consumption Report.xlsx';
        break;

      case 'OnOff Status':
        url = AppConfigData.getonOffStatusreportStatus;
        fileName = 'OnOff Status.xlsx';
        break;
      case 'PrepaidMeterOffStatusReport':
        url = AppConfigData.getPrepaidMeterOffStatusReportUrl;
        fileName = 'Prepaid Meter Off Status Report.xlsx';
        break;
      case 'Gateway Status':
        url = AppConfigData.getGatewayStatusReportUrl;
        fileName = 'Gateway Status Report.xlsx';
        break;
      case 'MeterMapping Report':
        url = AppConfigData.getutilityAllocationReport;
        fileName = 'MeterMapping Report.xlsx';
        break;
      default:
        console.error('Invalid report type');
        return;
    }

    // Define the HTTP options for the request
    const httpOptions = {
      responseType: 'blob' as 'blob', // Specify the response type as 'blob'
      observe: 'response' as const, // Observe the entire response
    };

    // Make the HTTP POST request
    this.http.post(url, payload, httpOptions).subscribe(
      (response: any) => {
        this.loaderService.setLoading(false);
        console.log(response);

        // Check if the response is a JSON object with "No Data Found" message
        response.body.text().then((text: any) => {
          try {
            const jsonResponse = JSON.parse(text);
            if (jsonResponse && jsonResponse.message === 'No Data Found.') {
              this.SharedService.showMessageDialog(
                jsonResponse.message,
                '',
                SweetAlertIcon.INFO
              );
              return;
            }
          } catch {
            // Not JSON, proceed to download as blob
            const blob = new Blob([response.body], {
              type: 'application/octet-stream',
            });

            // Create a link element for the file download
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName; // Set the download filename

            // Append the link to the body, click it, then remove it
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // Revoke the object URL after the download
            URL.revokeObjectURL(link.href);
          }
        });
      },
      (error) => {
        this.loaderService.setLoading(false);
        this.SharedService.showMessageDialog(
          error.error.message,
          this.ServiceError.Error,
          SweetAlertIcon.ERROR
        );
        console.error('Error downloading the report:', error);
      }
    );
  }

  exportReportMeterReadings(payload: any, reportType: string): Observable<any> {
    let url: string;
    let fileName: string;
    // Determine the URL and filename based on the report type
    switch (reportType) {
      case 'MeterReadings':
        url = AppConfigData.getMeterReadingReportUrl;
        fileName = 'Meter Readings Report.xlsx';
        break;
      case 'consumption':
        url = AppConfigData.getPrepaidConsumptionReportUrl;
        break;

      case 'DeviceCommunications':
        url = AppConfigData.getDeviceCommunicationnReportUrl;
        break;

      case 'WalletHistory':
        url = AppConfigData.getWalletHistoryReportUrl;
        break;

      case 'OnOffStatusReport':
        url = AppConfigData.getonOffStatusreportStatus;
        break;
      case 'PrepaidMeterOffStatusReport':
        url = AppConfigData.getPrepaidMeterOffStatusReportUrl;
        break;
      case 'GatewayStatusReport':
        url = AppConfigData.getGatewayStatusReportUrl;
        break;
      case 'HighConsumptionReport':
        url = AppConfigData.getHighConsumptionReportUrl;
        break;
      case 'ScheduleBilling':
        url = AppConfigData.getScheduleBillingReportUrl;
        break;

      default:
        console.error('Invalid report type');
        return throwError(() => new Error('Invalid report type'));
    }

    // Define the HTTP options for the request

    return this.http.post(url, payload).pipe(
      catchError((error) => {
        console.error('getTemplates failed:', error);
        this.SharedService.showMessageDialog(
          SweetAlertIcon.ERROR,
          this.ServiceError.Error,
          SweetAlertIcon.ERROR
        );
        return throwError(() => new Error());
      })
    );
  }

  // url = AppConfigData.getsettlementReportUrl;

  getAllsettlemetsExport(payload: any): Observable<any> {
    let url = AppConfigData.getsettlementReportUrl;
    return this.http.post<any>(url, payload).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('Settlement dtaa   failed:', error);
        return throwError(() => new Error()); // Rethrow the error to propagate it further
      })
    );
  }

  getFlatNumbersByProjectId(projectId: string): Observable<any> {
    return this.http
      .get<any>(AppConfigData.getFlatNumbers + projectId, {})
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => {
          console.error('feedbacklist  failed:', error);
          return throwError(() => new Error()); // Rethrow the error to propagate it further
        })
      );
  }

  getLatestMeterReadingsReportStatusService(
    userId: string,
    projectId: string,
    type: string
  ): Observable<any> {
    return this.http
      .get<any>(
        `${AppConfigData.getLatestMeterReadingsReportStatus}?UserId=${userId}&ProjectId=${projectId}&ReportName=${type}`,
        {}
      )
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => {
          console.error('getLatestMeterReadingsReportStatus  failed:', error);
          return throwError(() => new Error()); /// Rethrow the error to propagate it further
        })
      );
  }

  getLatestReportStatusService(
    userId: string,
    /* projectId: string, */
    type: string
  ): Observable<any> {
    return this.http
      .get<any>(
        `${AppConfigData.getLatestMeterReadingsReportStatus}?UserId=${userId}&ReportName=${type}`,
        {}
      )
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((error) => {
          console.error('getLatestMeterReadingsReportStatus  failed:', error);
          return throwError(() => new Error()); /// Rethrow the error to propagate it further
        })
      );
  }

  getProjectBillingType(billingType: string): Observable<any> {
    let url;
    url = `${AppConfigData.getProjectBillingType}`;
    const params = new HttpParams().set('billingType', billingType);
    return this.http.get<any>(url, { params }).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('projectbilling type failed:', error);
        return throwError(() => new Error()); // Rethrow the error to propagate it further
      })
    );
  }

  getConsumersByProjects(projectId: any): Observable<any> {
    let url;
    url = `${AppConfigData.getConsumersbyProjectsUrl + projectId}`;
    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('projectbilling type failed:', error);
        return throwError(() => new Error()); // Rethrow the error to propagate it further
      })
    );
  }

  getutilityproject(): Observable<any> {
    let url;
    url = `${AppConfigData.getutilityprojectUrl}`;
    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((error) => {
        console.error('projectbilling type failed:', error);
        return throwError(() => new Error()); // Rethrow the error to propagate it further
      })
    );
  }
}
